// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-application--is-ltr .v-list-item__action[data-v-b4b5b6ae]:first-child,.v-application--is-ltr .v-list-item__icon[data-v-b4b5b6ae]:first-child{margin-right:10px!important}.v-list-item[data-v-b4b5b6ae]{padding:0 10}.v-list-item__subtitle[data-v-b4b5b6ae],.v-list-item__title[data-v-b4b5b6ae]{white-space:normal;line-height:1.5}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
